//STUDENTS PROFILE ACTIONS----------------------------------------------------------------------------------------------
const profile = document.querySelector('.profile');
if (profile) {
    document.addEventListener("DOMContentLoaded", () => {
        paymentsList();
        coursesList();
    });

    //Delete student
    const stuDelBtn = document.getElementById('stu-del');
    stuDelBtn.addEventListener('click', (e) => {
        let sid = document.querySelector('.profile').dataset.sid;
        if (confirm(`Remove a student?`)) {
            postData('/actions/dash/stu_rem_stat.php', {sid: sid, action: 'del'}).then((data) => {
                if (data['res'] === 'success') {
                    window.location.href = '';
                }
            });
        }
    });

    //Add student to course
    const stuAddToCourseBtn = document.getElementById('stu-addtocourse');
    stuAddToCourseBtn.addEventListener('click', (e) => {
        //const selectedRadio = document.querySelector('input[name="gid"]:checked').dataset.cid;
        const selectedRadio = document.querySelector('input[name="gid"]:checked');
        if (selectedRadio) {
            document.querySelector('input[name="cid"]').value = selectedRadio.dataset.cid;
        }

        let form = document.querySelector('#addToCourse form'),
            formData = new FormData(form);
        const values = Object.fromEntries(formData.entries());

        if (values.gid) {
            let preloader = document.createElement('div');

            preloader.classList.add('position-absolute', 'd-flex', 'align-items-center', 'justify-content-center', 'z-2', 'm-3');
            preloader.style.cssText = 'left: 1rem;right: 1rem;top: 1rem;bottom: 1rem;background: rgba(255,255,255, 0.5);';
            preloader.innerHTML = '<div class="spinner-border text-brand-primary" role="status"><span class="visually-hidden">Loading...</span></div>'
            document.querySelector('#addToCourse .modal-content').appendChild(preloader);

            postData('/actions/dash/courses.php', values).then((data) => {
                if (data.success) {
                    const myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('addToCourse'));
                    myModal.hide();
                    preloader.remove();
                    coursesList();
                    document.querySelector(`#addToCourse #cid-${values.cid}`).remove();
                }
            }).catch(error => console.error(error));
        } else {
            document.querySelector('.toast-container').innerHTML += `<div id="liveToast" class="toast align-items-center rounded-3 text-white text-bg-danger" role="alert" aria-live="assertive" aria-atomic="true"><div class="d-flex"><div class="toast-body pt-3 ps-3">The course group was not selected</div><button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div></div>`;
            const toastLive = document.getElementById('liveToast')
            const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastLive);
            toastBootstrap.show();
            toastLive.addEventListener('hidden.bs.toast', () => {
                toastLive.remove();
            });
        }
    });

    //Delete student from course
    document.addEventListener('click', function (event) {
        if (event.target && event.target.matches('.del-from-group')) {
            event.preventDefault();
            if (confirm('Delete student from course?')) {
                postData('/actions/dash/courses.php', {
                    act: 10,
                    gid: event.target.dataset.gid,
                    sid: event.target.dataset.sid
                }).then((data) => {
                    if (data.success) {
                        coursesList();
                    }
                }).catch(error => console.error(error));
            }
        }
    });

    //Edit student personal info
    const stuEditBtn = document.querySelectorAll('.stuEdit');
    if (stuEditBtn) {
        stuEditBtn.forEach(elem => {
            elem.addEventListener('click', (e) => {
                if (elem.dataset.action === 'edit') {
                    elem.dataset.action = 'save';
                    elem.textContent = 'Save';
                    let stuEditInputs = document.querySelectorAll('.personal-info input, .personal-info select');
                    if (stuEditInputs) {
                        stuEditInputs.forEach((el) => {
                            if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
                                if (el.type === 'checkbox' || el.type === 'radio') {
                                    el.dataset.originalChecked = String(el.checked);
                                } else {
                                    el.dataset.originalValue = el.value;
                                }
                                el.readOnly = false;
                            } else if (el.tagName === 'SELECT') {
                                el.dataset.originalValue = el.value; // or use selectedIndex if preferred
                                el.disabled = false;
                            }
                            el.classList.toggle('form-control-plaintext', false);
                        });
                    }
                    const cancelEditBtn = document.createElement('button');
                    cancelEditBtn.textContent = 'Cancel';
                    cancelEditBtn.className = 'btn btn-link';
                    cancelEditBtn.style.cssText = 'padding: 0.5rem 1rem 0.4rem;';
                    elem.parentNode.insertBefore(cancelEditBtn, elem.nextSibling);

                    cancelEditBtn.addEventListener('click', (e) => {
                        // Restore original values
                        if (stuEditInputs) {
                            stuEditInputs.forEach((el) => {
                                if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
                                    if (el.type === 'checkbox' || el.type === 'radio') {
                                        if (el.dataset.originalChecked !== undefined) {
                                            el.checked = el.dataset.originalChecked === 'true';
                                        }
                                    } else if (el.dataset.originalValue !== undefined) {
                                        el.value = el.dataset.originalValue;
                                    }
                                    el.readOnly = true;
                                } else if (el.tagName === 'SELECT') {
                                    if (el.dataset.originalValue !== undefined) {
                                        el.value = el.dataset.originalValue;
                                    }
                                    el.disabled = true;
                                }

                                // Clear stored originals
                                delete el.dataset.originalValue;
                                delete el.dataset.originalChecked;
                                delete el.dataset.originalIndex;
                                el.classList.toggle('form-control-plaintext', true);
                            });
                        }

                        // Reset action button and remove cancel button
                        elem.dataset.action = 'edit';
                        elem.textContent = 'Edit';
                        cancelEditBtn.remove();
                    });
                } else if (elem.dataset.action === 'save') {
                    if (confirm('Save changes?')) {
                        let form = document.querySelector('.personal-info-form'),
                            formData = new FormData(form);
                        const values = Object.fromEntries(formData.entries());
                        values.action = 'edit';
                        values.sid = document.querySelector('.profile').dataset.sid;
                        console.log(values);                        
                        postData('/actions/dash/stu_edit.php', values).then((data) => {
                            console.log(data);
                            if (data[0] === 'success') {
                                document.querySelector('.toast-container').innerHTML += `<div id="liveToast" class="toast align-items-center rounded-3 text-white" role="alert" aria-live="assertive" aria-atomic="true"><div class="d-flex"><div class="toast-body pt-3 ps-3">${data[1]}</div><button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button></div></div>`;
                                const toastLive = document.getElementById('liveToast')
                                const toastBootstrap = bootstrap.Toast.getOrCreateInstance(toastLive);
                                toastBootstrap.show();
                                toastLive.addEventListener('hidden.bs.toast', () => {
                                    toastLive.remove();
                                });
                                // Make inputs read-only again
                                let stuEditInputs = document.querySelectorAll('.personal-info input, .personal-info select');
                                if (stuEditInputs) {
                                    stuEditInputs.forEach((el) => {
                                        el.readOnly = true;
                                        if (el.tagName === 'SELECT') {
                                            el.disabled = true;
                                        }
                                        el.classList.toggle('form-control-plaintext', true);
                                    });
                                }

                                // Reset action button and remove cancel button
                                elem.dataset.action = 'edit';
                                elem.textContent = 'Edit';
                                if (elem.nextSibling && elem.nextSibling.tagName === 'BUTTON' && elem.nextSibling.textContent === 'Cancel') {
                                    elem.nextSibling.remove();
                                }
                            }
                        }).catch(error => console.error(error));
                    }
                }
            });
        });
    }
}
//STUDENTS PROFILE ACTIONS END------------------------------------------------------------------------------------------